import { ApolloClient, ApolloQueryResult, NormalizedCacheObject } from '@apollo/client';
import Bugsnag from '@bugsnag/js';
import { handleQuery } from '@99designs/graph-utils';
import { ProductDetailsDocument, ProductDetailsQuery } from '../graphql/ProductDetails.generated';
import { mapDataToProductTypeArray } from './mapDataToProductTypeArray';
import type { ContestProduct, FixedPriceProjectProduct } from '../types';

export async function getProductsByProductNames(
    client: ApolloClient<NormalizedCacheObject>,
    productNames: string[]
): Promise<ContestProduct[] | FixedPriceProjectProduct[]> {
    const { data, error } = await fetchProducts(client, productNames);

    if (error) {
        return [];
    }

    if (!data || !data.products) {
        Bugsnag.notify(new Error('Feature Product details - products not found'), (event) => {
            event.context = `Product details not found for ${JSON.stringify(productNames)}`;
        });
        return [];
    }

    if (data.products.length <= 0) {
        Bugsnag.notify(new Error('Feature Product details - empty list of products'), (event) => {
            event.context = `Product details empty for ${JSON.stringify(productNames)}`;
        });
        return [];
    }

    return mapDataToProductTypeArray(data);
}

function fetchProducts(
    client: ApolloClient<NormalizedCacheObject>,
    productNames: string[]
): Promise<ApolloQueryResult<ProductDetailsQuery>> {
    return handleQuery<ProductDetailsQuery>(client, {
        query: ProductDetailsDocument,
        variables: {
            input: {
                names: productNames,
            },
        },
    });
}
